"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var sharedStyles = _interopRequireWildcard(require("../../styles/styled"));
var _BRAND_ICON = _interopRequireDefault(require("../../images/BRAND_ICON.png"));
var _BRAND_ICON_NEGATIVE = _interopRequireDefault(require("../../images/BRAND_ICON_NEGATIVE.png"));
var _colors = _interopRequireDefault(require("../../constants/colors"));
var _templateObject;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var styles = {
  container: {
    display: 'flex',
    alignItems: 'center'
  },
  image: function image(height) {
    return {
      height: height,
      width: 'auto'
    };
  }
};
var Text = _styledComponents["default"].span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  margin-left: 10px;\n  font-size: 18px;\n  letter-spacing: 0.05em;\n  color: ", ";\n"])), sharedStyles.menuFont, function (_ref) {
  var showAsNegative = _ref.showAsNegative;
  return showAsNegative ? '#fff' : _colors["default"].BRAND_COLOR_BODY;
});
var Logo = function Logo(_ref2) {
  var height = _ref2.height,
    showText = _ref2.showText,
    showAsNegative = _ref2.showAsNegative;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.container
  }, showAsNegative ? /*#__PURE__*/_react["default"].createElement("img", {
    style: styles.image(height),
    src: _BRAND_ICON_NEGATIVE["default"],
    alt: "logo"
  }) : /*#__PURE__*/_react["default"].createElement("img", {
    style: styles.image(height),
    src: _BRAND_ICON["default"],
    alt: "logo"
  }), showText ? /*#__PURE__*/_react["default"].createElement(Text, {
    showAsNegative: showAsNegative
  }, "DABEA") : null);
};
Logo.propTypes = {
  showText: _propTypes["default"].bool,
  showAsNegative: _propTypes["default"].bool,
  height: _propTypes["default"].number.isRequired
};
Logo.defaultProps = {
  showText: true,
  showAsNegative: false
};
var _default = exports["default"] = Logo;